import { FEATURE_TOUR_IDS } from '@va/constants';
import { BulbIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button } from '@va/ui/design-system';
import { Portal } from '@va/util/components';
import { useWindowDimensions } from '@va/util/hooks';
import classNames from 'classnames';
import { useMemo } from 'react';

export const FeatureTourButton = ({
  completed,
  onClick,
  disabled,
}: {
  completed: boolean;
  onClick: () => void;
  disabled?: boolean;
}) => {
  const translate = useTranslate();
  const { width } = useWindowDimensions();

  const hideText = useMemo(() => width < 1480, [width]);

  const btnText = useMemo(() => {
    if (completed) return translate('all.featureTour.complete');
    if (!completed) return translate('all.featureTour.available');
  }, [completed, translate]);

  return (
    <Portal elementSelector={`#${FEATURE_TOUR_IDS.openTourContainerButton}`}>
      <Button
        color={completed ? 'tertiary' : 'primary'}
        onClick={onClick}
        disabled={disabled}
        icon={(_, color) => <BulbIcon color={color} />}
        text={hideText ? undefined : btnText}
        tooltip={hideText ? btnText : undefined}
        className={classNames('max-w-58.5', { 'h-60px': !hideText })}
      />
    </Portal>
  );
};
